<template>
  <div id="app">
    <div v-if="!routesReady">
      <LoadingSpinner :toggle="true"/>
    </div>
    <template v-else-if="routesReady && isAuthenticated"> 
      <!-- v-if="isAuthenticated" ts: <div :class="config.style.background+' '+config.font.body" v-if="isAuthenticated">-->
      <div :class="appConfig.app_classes">
        <router-view :key="$route.fullPath" />
        <modals-container />
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

import Api from '@/components/Api'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  name: 'App',
  metaInfo: {
    title: 'App',
    titleTemplate: '%s | '+ (process.env.VUE_APP_NAME || 'ReSole')
  },
  mixins: [Api],
  components: {
    LoadingSpinner
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      user: 'auth/user',
      locale: 'app/locale',
      showUserMenu: 'app/showUserMenu',
      appConfig: 'app/appConfig',
    }),
  },
  data: () => ({
    show: true,
    routesReady: false,
    app_config: {
      app_classes: null,
      layout_container_classes: null,
      layout_content_classes: null,
      header_container_classes: null,
      main_container_classes: null,
      footer_container_classes: null,
      menu_type: null,
      menus: null
    },
    views: {
      "page": () => import("@/views/templates/Page.vue"),
      "search": () => import("@/views/templates/Search.vue"),
      "map": () => import("@/views/templates/Map.vue"),
      "card_container": () => import("@/views/CardContainer.vue"),
      "login": () => import("@/views/Login.vue"),
      "register": () => import("@/views/Register.vue"),
      "profile": () => import("@/views/Profile.vue"),
      "verify-email": () => import("@/views/VerifyEmail.vue"),
      "reset-password": () => import("@/views/ResetPassword.vue"),
      "touch-home": () => import("@/views/touch/Home.vue"),
      "touch-archive": () => import("@/views/touch/Archive.vue"),
      "touch-webframe-gallery": () => import("@/views/touch/WebFrameGallery.vue"),
      "touch-landing": () => import("@/views/touch/Landing.vue"),
      "touch-video-gallery": () => import("@/views/touch/VideoGallery.vue"),
      "touch-webmap": () => import("@/views/touch/WebMap.vue"),
      "touch-panels": () => import("@/views/touch/Panels.vue"),
      "touch-carousel": () => import("@/views/touch/Carousel.vue"),
      "touch-webframe": () => import("@/views/touch/WebFrame.vue"),
      "webframe": () => import("@/views/WebFrame.vue"),
      "webframe-gallery": () => import("@/views/WebFrameGallery.vue"),
    }
  }),
  async created() {
    const vm = this
    vm.loading = true
  },
  async beforeMount(){
    const vm = this
    let routes = []
    // Register routes
    if(vm.isAuthenticated) await vm.get(`web/projects/${process.env.VUE_APP_PROJECT}`).then(response => {
      if(!response.home && response.pages.length === 0 && this.$route.name !== 'not-found') {
        vm.$router.push({name: 'not-found'})
      }
      if(response.home) {
        routes.push({path: '/', name: 'index', component: vm.views[response.home.template] || vm.views['page']})
      }
      if(response.pages) response.pages.forEach(page => {
        routes.push({path: `/${page.page_slug}/:token?`, name: page.page_slug, component: vm.views[page.template] || vm.views['page']})
      })
      if(response.posts) response.posts.forEach(post => {
        routes.push({path: `/post/${post.post_slug}/:token?`, name: post.post_slug, component: vm.views['page'], props: { model: 'posts'}})
      })
      if(response.card_container_types) response.card_container_types.forEach(card_container_type => {
        routes.push({path: `/${card_container_type.code}/:slug/:token?`, name: card_container_type.code, component: vm.views['card_container'], props: { model: 'card_containers'}})
      })
      if(response.enable_profiles) {
        routes.push({path: `/login`, name: 'login', component: vm.views['login']})
        routes.push({path: `/register`, name: 'register', component: vm.views['register']})
        routes.push({path: `/profile`, name: 'profile', component: vm.views['profile']})
        routes.push({path: `/verify-email`, name: 'verify-email', component: vm.views['verify-email']})
        routes.push({path: `/reset-password`, name: 'reset-password', component: vm.views['reset-password']})
      }
      vm.$router.addRoutes(routes)
      vm.$store.dispatch(`app/appConfig`, {appConfig: response})
      if(routes.length > 0) vm.routesReady = true
    }).catch(error => {
      console.log(error)
      vm.$router.push({name: 'not-found'})
    })
  },
  methods: {
    hideUserMenu(){
      this.$store.dispatch(`app/showUserMenu`, {showUserMenu: false})
    },
    showNav(show){
      this.show = show
    }
  },
}
</script>